<div class="modal-overlay" (click)="fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-trash-alt text-danger"></i> Confirmar Deleção
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12" *ngIf="contaParaDeletar">
        <p>Você tem certeza que deseja remover a conta <strong>{{ contaParaDeletar.descricao }}</strong> no valor de <strong>{{ contaParaDeletar.valor | currency:'BRL' }}</strong>?</p>
        <p class="text-muted small">Esta ação não poderá ser desfeita.</p>
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()">Cancelar</button>
        <button type="button" class="btn btn-danger px-4 d-flex align-items-center gap-2" (click)="confirmarDelecao()">
          Confirmar Deleção
        </button>
      </div>
    </div>
  </div>
</div>
